export default __webpack_public_path__ + "static/media/icewall.3fff7c92.mpeg";